/**
 * Application constants and configuration
 */

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
export const API_BASE = `${BACKEND_URL}/api`;

export const PERFORMANCE_CONFIG = {
  PAGINATION_SIZE: 20,
  DEBOUNCE_DELAY: 300,
  POLLING_INTERVAL: 2000,
  MAX_CONCURRENT_REQUESTS: 3,
  CACHE_TIMEOUT: 5 * 60 * 1000, // 5 minutes
};

export const INTERVIEW_STATUS = {
  DRAFT: 'draft',
  ACTIVE: 'active',
  COMPLETED: 'completed',
  ARCHIVED: 'archived',
};

export const PRIORITY_LEVELS = {
  LOW: 'low',
  NORMAL: 'normal',
  HIGH: 'high',
  URGENT: 'urgent',
};

export const AI_TASKS = {
  SCRAPING: 'scraping',
  CLEANED_TRANSCRIPT: 'cleaned_transcript',
  ASSET_CLASS_TAGGING: 'asset_class_tagging',
  LOCATION_TAGGING: 'location_tagging',
  AI_TAGS: 'ai_tags',
};

export const JOB_STATUS = {
  QUEUED: 'queued',
  RUNNING: 'running',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
  PAUSED: 'paused',
};

export const ARTICLE_TYPES = {
  FEATURE: 'feature',
  PERSPECTIVE: 'perspective',
  SUMMARY: 'summary',
};

export const ARTICLE_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  ARCHIVED: 'archived',
};

export const ACTIVITY_TYPES = {
  INTERVIEW_CREATED: 'INTERVIEW_CREATED',
  INTERVIEW_UPDATED: 'INTERVIEW_UPDATED',
  INTERVIEW_DELETED: 'INTERVIEW_DELETED',
  AI_PROCESSING: 'AI_PROCESSING',
  ARTICLE_GENERATED: 'ARTICLE_GENERATED',
  CSV_IMPORT: 'CSV_IMPORT',
  JOB_CREATED: 'JOB_CREATED',
  BATCH_CREATED: 'BATCH_CREATED',
};

export const FILTER_OPTIONS = {
  INDUSTRY_VERTICALS: [
    'Real Estate',
    'Technology',
    'Healthcare',
    'Finance',
    'Manufacturing',
    'Retail',
    'Education',
    'Government',
    'Non-Profit',
    'Other',
  ],
  PRIORITIES: [
    { value: 'low', label: 'Low', color: 'gray' },
    { value: 'normal', label: 'Normal', color: 'blue' },
    { value: 'high', label: 'High', color: 'orange' },
    { value: 'urgent', label: 'Urgent', color: 'red' },
  ],
};
/**
 * Turn an image URL from the API into one the browser can actually load.
 *
 * Images reach the frontend in TWO shapes and always have: RELATIVE paths for anything in our own
 * object storage ("/api/content-studio/files/…", "/api/images/…"), and ABSOLUTE URLs for anything
 * externally hosted (historic stock-licensed article images are the live example). A relative src
 * resolves against the FRONTEND origin, which does not serve /api, so it renders broken — and
 * blind concatenation does the mirror damage, turning a perfectly good absolute URL into
 * "https://frontend.example.comhttps://cdn…".
 *
 * Centralised because this was previously duplicated in two components and hand-rolled as bare
 * `${BACKEND_URL}${url}` in three more; the hand-rolled ones only worked because their inputs
 * happen to be relative today, which is exactly the kind of accident that breaks later.
 */
export const resolveImageUrl = (url) =>
  (url && url.startsWith('/')) ? `${BACKEND_URL}${url}` : url;
